const initialState = {
    all_Quotes: [],
};

const quotesReducers = (state = initialState, action) => {
    switch (action.type) {
        case "ALL_QUOTES":
            return {
                ...state,
                all_Quotes: action.payload,
            };


        default:
            return state;
    }
};

export default quotesReducers;
